import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=65e3b91c&scoped=true&"
import script from "./Stack.vue?vue&type=script&lang=ts&"
export * from "./Stack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3b91c",
  null
  
)

export default component.exports